import axios from 'axios';
import moment from 'moment';
import LaravelRouter from '../../thirdparty/Ziggy/route.js';
import {arrayChunk, saveVuexState, getVuexState} from '../../util/common'
let default_search = () => {
    return JSON.parse(JSON.stringify({
        id: null,
        make: '',
        model: null,
        year_min: 1996,
        year_max: '',
        condition_min: 4,
        condition_max: 9,
        mileage_min: null,
        mileage_max: null,
        transmission: null,
        chassis: null,
        engine_cc_min: null,
        engine_cc_max: null,
        fuel_type: null,
        driving_side: null,
        start_bid_min: null,
        start_bid_max: null,
        colour: null,
        lot: null,
        exclude_year_max: null,
        exclude_year_min: null,
        excluded_makes: [],
    }))
};
let normalizeMake = make => {
    if (!make) {
        return ''
    }
    if (make === 'foreign-other') {
        return make
    }
    return make
}

const saveState = (state) => {
    saveVuexState('market_research_state', state)
}

const state = getVuexState('market_research_state', {
    loading: false,
    makes: [],
    all_makes: [],
    translated_grades: {},
    years: [],
    resultsCache: {
        results: '',
        time: null,
        key: null
    },
    search_data: default_search(),
    isFromSessionStorage: false,
    currentPage: 1,
    perPage: 500
});


// getters
const getters = {
    makes: (state, getters, rootState) => {
        return state.makes;
    },
    all_makes: (state, getters, rootState) => {
        return state.all_makes;
    },
    resultsCache: (state, getters, rootState) => {
        return state.resultsCache;
    },
    date_counters: (state, getters, rootState) => {
        return state.date_counters;
    },
    years: (state, getters, rootState) => {
        return state.years;
    },
    search_data: (state, getters, rootState) => {
        return state.search_data;
    },
    translated_grades: (state, getters, rootState) => {
        return state.translated_grades;
    },
    loading: (state, getters, rootState) => {
        return state.loading;
    },
    isFromSessionStorage: state => state.isFromSessionStorage,
    getCurrentPage: state => state.currentPage,
    getPerPage: state => state.perPage
};

let searchDataPromise,translateGradeInterval, translateGradePromise, translateGradeResolve,
    translateGradeVehicles = []

// actions
const actions = {
    async setSearchSeen({ commit, state }, searchId) {
        const data_route = LaravelRouter('saved_search.seen', searchId, true);
        axios.get(data_route)
    },
    async maybeGetSearchData({ commit, state, dispatch }, args) {
        if (!searchDataPromise) {
            // if this function is called multiple times we will return the same promise,
            // so the ajax call will only run once.
            searchDataPromise = dispatch('getSearchData', args);
        }
        return searchDataPromise;
    },
    async getSearchData({ commit, state }, args){
        if (!args) {
            args = {};
        }
        args = Object.assign({
            dates: state.selected_dates,
        }, args)
        commit('setLoading', true);
        let data_route = LaravelRouter('auction.search_data', args, true);
        let makes_route = LaravelRouter('auction.makes', args, true);
        let makes_res = axios.get(data_route);
        let data_res = axios.get(makes_route);
        let results = await Promise.all([makes_res, data_res]);

        commit('setLoading', false);
        if (results && results[0].data && results[1].data) {
            let data = {...results[0].data, ...results[1].data};
            commit('setSearchData', data);
            return data;
        } else {
            throw {message: 'There was a problem', results};
        }
    },
    async getMakes({ commit, state, dispatch }, args) {
        let makes_route = LaravelRouter('auction.makes', args, true);
        let makes_res = await axios.get(makes_route);
        if (makes_res.makes) {
            commit('setMakes', makes_res.makes);
        }
        return searchDataPromise;
    },
    async getModelsByMake({commit, state}, {make}) {
        try {
            let args = {make};
            let url = this._vm.$laravelRoute('auction.models');
            let response = await axios.get(url, {params: args})
            if (response && response.data && response.data.models) {
                return response.data.models;
            }
        } catch (e) {
            console.warn(e);
        }
        return [];
    },
    /**
     * This will wait 300ms and queue up all calls to this function. So it can be called 500 times by Vehicle component.
     * The same promise is returned to all calls.
     * @param commit
     * @param state
     * @param dispatch
     * @param vehicle
     * @returns {Promise<any>}
     */
    translateGrade({commit, state, dispatch}, vehicle) {
        clearInterval(translateGradeInterval)
        translateGradeVehicles.push(vehicle)
        translateGradeInterval = setInterval(() => {
            dispatch('translateGrades', translateGradeVehicles).then(res => {
                translateGradeResolve(res)
                translateGradeResolve = null
            }).catch(console.warn);

            clearInterval(translateGradeInterval)
            translateGradeVehicles = []
            translateGradePromise = null
        }, 300)

        if (!translateGradePromise) {
            translateGradePromise = new Promise((resolve, reject) => {
                translateGradeResolve = resolve; //this is hacky but i couldn't think of a better way...
            })
        }
        return translateGradePromise;
    },
    translateGrades({commit, state}, vs){
        return new Promise((resolve, reject) => {
            let translated_grades = {}
            let promises = []
            if (vs && vs.length) {
                let chunks = arrayChunk(vs, 100)
                chunks.forEach(vehicles => {
                    let grades = [];
                    let grades_vehicle_map = {};
                    let i = 0;
                    vehicles.forEach(v => {
                        if (v.grade) {
                            grades.push(v.grade)
                            grades_vehicle_map[v.api_id] = i
                            i++
                        }
                    })
                    if (grades.length) {
                        let args = {text: grades, source: 'ja'}
                        let pm = axios.post('/translate-batch', args)
                        promises.push(pm)
                        pm.then(res => {
                            if (res && res.data && res.data.translations && res.data.translations.length === grades.length) {
                                vehicles.forEach((v, i) => {
                                    let match = false
                                    if (grades_vehicle_map[v.api_id] && res.data.translations[grades_vehicle_map[v.api_id]] !== v.grade) {
                                        match = true
                                        translated_grades[v.api_id] = res.data.translations[grades_vehicle_map[v.api_id]]
                                    }
                                })
                            }
                        })
                    }
                })
                Promise.all(promises).then(all_res => {
                    setTimeout(() => {
                        commit('setTranslatedGrades', translated_grades)
                        setTimeout(() => {
                            resolve(translated_grades)
                        },2)
                    },2)
                })
            }
        })
    },
};

// mutations
const mutations = {
    setSearchData (state, result) {
        state.makes = result.makes;
        state.all_makes = result.all_makes;
        state.years = result.years;
        saveState(state)
    },
    setTranslatedGrades (state, translated_grades) {
        state.translated_grades = Object.assign(state.translated_grades, translated_grades)
        saveState(state)
    },
    setResultsCache (state, {results, key}) {
        state.resultsCache.results = JSON.stringify(results)
        state.resultsCache.key = key
        state.resultsCache.time = moment().format('X')
        saveState(state)
    },
    setMakes(state, makes){
        this._vm.set(state, 'makes', makes);
        saveState(state)
    },
    setGetData(state, value){
        state.get_data = value;
        saveState(state)
    },
    setLoading(state, value){
        state.loading = value;
        saveState(state)
    },
    setSearch(state, data){
        let make = data.make || '';
        if (data.make && data.make.name) {
            make = data.make.name;
        }
        let excluded_makes = []
        if (data.excluded_makes) {
            if (typeof data.excluded_makes === 'string') {
                excluded_makes = data.excluded_makes.split(',');
            } else {
                if (data.excluded_makes.length) {
                    data.excluded_makes.forEach(mk => {
                        let name;
                        if (typeof mk === 'string') {
                            name = mk
                        } else {
                            name = mk.name || ''
                        }
                        if (name) {
                            excluded_makes.push(name)
                        }
                    })
                }
            }
        }
        let model = null;
        if (data.model) {
            model = data.model;
        }
        state.search_data.make = normalizeMake(make);
        state.search_data.model = model;
        state.search_data.year_min = data.year_min || null;
        state.search_data.year_max = data.year_max || null;
        state.search_data.condition_min = data.condition_min || 4;
        state.search_data.condition_max = data.condition_max || 9;
        state.search_data.mileage_min = data.mileage_min || null;
        state.search_data.mileage_max = data.mileage_max || null;
        state.search_data.transmission = data.transmission || null;
        state.search_data.chassis = data.chassis || null;
        state.search_data.excluded_makes = excluded_makes;
        state.search_data.engine_cc_min = data.engine_cc_min || null;
        state.search_data.engine_cc_max = data.engine_cc_max || null;
        state.search_data.fuel_type = data.fuel_type || null;
        state.search_data.driving_side = data.driving_side || null;
        state.search_data.start_bid_min = data.start_bid_min || null;
        state.search_data.start_bid_max = data.start_bid_max || null;
        state.search_data.colour = data.colour || null;
        state.search_data.lot = data.lot || null;
        state.search_data.exclude_year_max = data.exclude_year_max || null;
        state.search_data.exclude_year_min = data.exclude_year_min || null;
        state.search_data.hour_ago = data.hour_ago || null;
        saveState(state)
    },
    resetSearch(state){
        state.search_data = default_search();
        saveState(state)
    },
    setSearchProperty(state, {prop, value}){
        if (state.search_data.hasOwnProperty(prop)) {
            state.search_data[prop] = value;
        } else {
            console.warn('Trying to set unknown property', {prop, value});
        }
        saveState(state)
    },
    setCurrentPage ( state, page ) {
        state.currentPage = page
        saveState(state)
    },
    setPerPage ( state, perPage ) {
        state.perPage = perPage
        saveState(state)
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./resources/js/store/modules/market_research.js